(function () {
  var DAY_NAMES = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];

  function safeParse(json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      return null;
    }
  }

  function normalizeObject(value) {
    return value && typeof value === "object" && !Array.isArray(value)
      ? value
      : {};
  }

  function splitStringList(value) {
    if (Array.isArray(value)) return value;
    if (typeof value !== "string") return [];
    return value
      .split(/[\n,]+/)
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);
  }

  function normalizeDayList(value, fallback) {
    var source = Array.isArray(value) ? value : splitStringList(value);
    var days = source
      .map(function (day) {
        return String(day).trim().toLowerCase();
      })
      .filter(function (day) {
        return DAY_NAMES.indexOf(day) !== -1;
      });

    if (Array.isArray(value)) return days;
    if (typeof value === "string" && value.trim() !== "") return days;
    return days.length ? days : fallback.slice();
  }

  function normalizeHiddenDates(value) {
    return splitStringList(value).filter(function (dateKey) {
      return /^\d{4}-\d{2}-\d{2}$/.test(dateKey);
    });
  }

  function hasOwn(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }

  function getConfigValue(productConfig, globalConfig, key, fallback) {
    if (
      hasOwn(productConfig, key) &&
      productConfig[key] !== null &&
      productConfig[key] !== ""
    ) {
      return productConfig[key];
    }

    if (
      hasOwn(globalConfig, key) &&
      globalConfig[key] !== null &&
      globalConfig[key] !== ""
    ) {
      return globalConfig[key];
    }

    return fallback;
  }

  function parsePositiveInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
  }

  function parseCutoffTime(value) {
    var raw = String(value || "").trim();
    var match24 = raw.match(/^(\d{1,2}):(\d{2})$/);
    var match12 = raw.match(/^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)$/i);

    if (match24) {
      var hours24 = parseInt(match24[1], 10);
      var minutes24 = parseInt(match24[2], 10);
      if (hours24 >= 0 && hours24 <= 23 && minutes24 >= 0 && minutes24 <= 59) {
        return { hours: hours24, minutes: minutes24 };
      }
    }

    if (match12) {
      var hours12 = parseInt(match12[1], 10);
      var minutes12 = parseInt(match12[2] || "0", 10);
      var meridiem = match12[3].toUpperCase();

      if (hours12 >= 1 && hours12 <= 12 && minutes12 >= 0 && minutes12 <= 59) {
        if (meridiem === "AM" && hours12 === 12) hours12 = 0;
        if (meridiem === "PM" && hours12 !== 12) hours12 += 12;
        return { hours: hours12, minutes: minutes12 };
      }
    }

    return { hours: 15, minutes: 0 };
  }

  function utcDateFromKey(dateKey) {
    var parts = dateKey.split("-").map(function (part) {
      return parseInt(part, 10);
    });
    return new Date(Date.UTC(parts[0], parts[1] - 1, parts[2], 12, 0, 0));
  }

  function formatDateKey(date) {
    var year = date.getUTCFullYear();
    var month = String(date.getUTCMonth() + 1).padStart(2, "0");
    var day = String(date.getUTCDate()).padStart(2, "0");
    return year + "-" + month + "-" + day;
  }

  function addCalendarDays(dateKey, amount) {
    var date = utcDateFromKey(dateKey);
    date.setUTCDate(date.getUTCDate() + amount);
    return formatDateKey(date);
  }

  function weekdayFromKey(dateKey) {
    return DAY_NAMES[utcDateFromKey(dateKey).getUTCDay()];
  }

  function getLocalParts(date, timeZone) {
    var formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: timeZone,
      weekday: "long",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23",
    });

    return formatter.formatToParts(date).reduce(function (accumulator, part) {
      if (part.type !== "literal") accumulator[part.type] = part.value;
      return accumulator;
    }, {});
  }

  function isDateAllowed(dateKey, allowedDays, hiddenDatesSet) {
    return (
      allowedDays.indexOf(weekdayFromKey(dateKey)) !== -1 &&
      !hiddenDatesSet.has(dateKey)
    );
  }

  function nextEligibleDate(
    startDateKey,
    allowedDays,
    hiddenDatesSet,
    includeStart,
  ) {
    var current = includeStart
      ? startDateKey
      : addCalendarDays(startDateKey, 1);

    for (var index = 0; index < 370; index += 1) {
      if (isDateAllowed(current, allowedDays, hiddenDatesSet)) {
        return current;
      }
      current = addCalendarDays(current, 1);
    }

    return null;
  }

  function alignToAllowedDate(startDateKey, allowedDays, hiddenDatesSet) {
    if (!allowedDays.length) return startDateKey;

    var current = startDateKey;

    for (var index = 0; index < 370; index += 1) {
      if (isDateAllowed(current, allowedDays, hiddenDatesSet)) {
        return current;
      }
      current = addCalendarDays(current, 1);
    }

    return startDateKey;
  }

  function addAllowedDays(startDateKey, amount, allowedDays, hiddenDatesSet) {
    var alignedStart = alignToAllowedDate(
      startDateKey,
      allowedDays,
      hiddenDatesSet,
    );

    if (amount <= 0) return alignedStart;

    var current = alignedStart;
    var counted = 0;

    for (var index = 0; index < 500; index += 1) {
      current = addCalendarDays(current, 1);

      if (isDateAllowed(current, allowedDays, hiddenDatesSet)) {
        counted += 1;
        if (counted >= amount) return current;
      }
    }

    return current;
  }

  function parseOffsetMinutes(offsetLabel) {
    var match = String(offsetLabel || "").match(
      /GMT([+-])(\d{1,2})(?::?(\d{2}))?/i,
    );
    if (!match) return 0;

    var sign = match[1] === "-" ? -1 : 1;
    var hours = parseInt(match[2], 10);
    var minutes = parseInt(match[3] || "0", 10);
    return sign * (hours * 60 + minutes);
  }

  function getOffsetMinutes(date, timeZone) {
    var formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: timeZone,
      timeZoneName: "shortOffset",
      hour: "2-digit",
    });

    var timeZoneName = formatter.formatToParts(date).find(function (part) {
      return part.type === "timeZoneName";
    });

    return parseOffsetMinutes(timeZoneName && timeZoneName.value);
  }

  function zonedTimeToUtc(dateKey, hours, minutes, timeZone) {
    var parts = dateKey.split("-").map(function (part) {
      return parseInt(part, 10);
    });
    var guess = new Date(
      Date.UTC(parts[0], parts[1] - 1, parts[2], hours, minutes, 0),
    );
    var offsetMinutes = getOffsetMinutes(guess, timeZone);
    var actual = new Date(guess.getTime() - offsetMinutes * 60000);
    var verifiedOffset = getOffsetMinutes(actual, timeZone);

    if (verifiedOffset !== offsetMinutes) {
      actual = new Date(guess.getTime() - verifiedOffset * 60000);
    }

    return actual;
  }

  function formatCountdown(diffMs) {
    var totalMinutes = Math.max(0, Math.floor(diffMs / 60000));
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    return hours + " hours, " + minutes + " minutes";
  }

  function formatDateParts(dateKey, options) {
    var formatter = new Intl.DateTimeFormat(
      "en-US",
      Object.assign({ timeZone: "UTC" }, options),
    );
    return formatter.formatToParts(utcDateFromKey(dateKey)).reduce(function (
      accumulator,
      part,
    ) {
      if (part.type !== "literal") accumulator[part.type] = part.value;
      return accumulator;
    }, {});
  }

  function formatBannerDate(dateKey) {
    var parts = formatDateParts(dateKey, {
      month: "2-digit",
      day: "2-digit",
      weekday: "long",
    });
    return parts.month + "/" + parts.day + " (" + parts.weekday + ")";
  }

  function formatTimelineDate(dateKey) {
    var parts = formatDateParts(dateKey, { day: "2-digit", month: "short" });
    return parts.day + " " + parts.month;
  }

  function formatRange(startDateKey, endDateKey, formatter) {
    var start = formatter(startDateKey);
    var end = formatter(endDateKey);
    return startDateKey === endDateKey ? start : start + " - " + end;
  }

  function normalizeConfig(payload) {
    var globalConfig = normalizeObject(payload.global);
    var productConfig = normalizeObject(payload.product);
    var timezone = getConfigValue(
      productConfig,
      globalConfig,
      "timezone",
      "America/New_York",
    );
    var cutoff = parseCutoffTime(
      getConfigValue(productConfig, globalConfig, "cutoffTime", "15:00"),
    );
    var hiddenDates = normalizeHiddenDates(
      getConfigValue(productConfig, globalConfig, "hiddenDates", []),
    );

    return {
      enabled: Boolean(
        getConfigValue(productConfig, globalConfig, "enabled", true),
      ),
      timezone: timezone,
      cutoffHours: cutoff.hours,
      cutoffMinutes: cutoff.minutes,
      leadTime: parsePositiveInteger(
        getConfigValue(productConfig, globalConfig, "leadTime", 3),
        3,
      ),
      range: parsePositiveInteger(
        getConfigValue(productConfig, globalConfig, "range", 0),
        0,
      ),
      handlingTime: parsePositiveInteger(
        getConfigValue(productConfig, globalConfig, "handlingTime", 0),
        0,
      ),
      showDays: normalizeDayList(
        getConfigValue(productConfig, globalConfig, "showDays", DAY_NAMES),
        DAY_NAMES,
      ),
      dispatchDays: normalizeDayList(
        getConfigValue(
          productConfig,
          globalConfig,
          "dispatchDays",
          DAY_NAMES.slice(1, 6),
        ),
        DAY_NAMES.slice(1, 6),
      ),
      activeDeliveryDays: normalizeDayList(
        getConfigValue(
          productConfig,
          globalConfig,
          "activeDeliveryDays",
          DAY_NAMES.slice(1, 6),
        ),
        DAY_NAMES.slice(1, 6),
      ),
      hiddenDates: hiddenDates,
      hiddenDatesSet: new Set(hiddenDates),
    };
  }

  function computeState(config) {
    if (
      !config.enabled ||
      !config.showDays.length ||
      !config.dispatchDays.length ||
      !config.activeDeliveryDays.length
    ) {
      return null;
    }

    var now = new Date();
    var nowLocal = getLocalParts(now, config.timezone);
    var todayKey = nowLocal.year + "-" + nowLocal.month + "-" + nowLocal.day;
    var currentMinutes =
      parseInt(nowLocal.hour, 10) * 60 + parseInt(nowLocal.minute, 10);
    var cutoffMinutes = config.cutoffHours * 60 + config.cutoffMinutes;

    if (!isDateAllowed(todayKey, config.showDays, config.hiddenDatesSet)) {
      return null;
    }

    var orderDateKey;

    if (currentMinutes < cutoffMinutes) {
      orderDateKey = todayKey;
    } else {
      orderDateKey = nextEligibleDate(
        todayKey,
        config.showDays,
        config.hiddenDatesSet,
        false,
      );
    }

    if (!orderDateKey) return null;

    var countdownTarget = zonedTimeToUtc(
      orderDateKey,
      config.cutoffHours,
      config.cutoffMinutes,
      config.timezone,
    );
    var processingEnd = addAllowedDays(
      orderDateKey,
      config.handlingTime,
      config.dispatchDays,
      config.hiddenDatesSet,
    );
    var deliveryStart = addAllowedDays(
      processingEnd,
      config.leadTime,
      config.activeDeliveryDays,
      config.hiddenDatesSet,
    );
    var deliveryEnd = addAllowedDays(
      deliveryStart,
      config.range - 1,
      config.activeDeliveryDays,
      config.hiddenDatesSet,
    );

    return {
      countdown: formatCountdown(countdownTarget.getTime() - now.getTime()),
      bannerRange: formatRange(deliveryStart, deliveryEnd, formatBannerDate),
      timelineHeading:
        formatRange(deliveryStart, deliveryEnd, formatTimelineDate) +
        " Estimated arrival",
      orderDate: formatTimelineDate(orderDateKey),
      processingDate: formatRange(
        orderDateKey,
        processingEnd,
        formatTimelineDate,
      ),
      estimateDate: formatRange(deliveryStart, deliveryEnd, formatTimelineDate),
    };
  }

  function render(root, state) {
    if (!state) {
      root.hidden = true;
      return;
    }

    root.hidden = false;
    root.querySelector("[data-delivery-countdown]").textContent =
      state.countdown;
    root.querySelector("[data-delivery-banner-range]").textContent =
      state.bannerRange;
    root.querySelector("[data-delivery-heading]").textContent =
      state.timelineHeading;
    root.querySelector("[data-delivery-order-date]").textContent =
      state.orderDate;
    root.querySelector("[data-delivery-processing-date]").textContent =
      state.processingDate;
    root.querySelector("[data-delivery-estimate-date]").textContent =
      state.estimateDate;
  }

  function mount(root) {
    if (root.dataset.deliveryTimerMounted === "true") return;

    var configNode = root.querySelector("[data-delivery-timer-config]");
    if (!configNode) return;

    var payload = safeParse(configNode.textContent);
    if (!payload) return;

    var config = normalizeConfig(payload);

    var update = function () {
      render(root, computeState(config));
    };

    update();
    window.setInterval(update, 1000);
    root.dataset.deliveryTimerMounted = "true";
  }

  function initDeliveryTimers() {
    document.querySelectorAll("[data-delivery-timer]").forEach(mount);
  }

  document.addEventListener("DOMContentLoaded", initDeliveryTimers);
  document.addEventListener("shopify:section:load", initDeliveryTimers);
})();
